<template>
	<div class="My_pop _popRight _popdetails" id="POP-CAdetails-1" style="display: block;">
		<!-- POP -->
		<div class="pop_right " style="right: 0px;" v-loading="loadingMask">
			<!-- pop_right -->
			<ul class="pop_right_header2">
				<li>
					<h2>集团绑定</h2>
				</li>
				<li>
					<btn class="pop_right_close2" name="pop-details-close" @click="closeFloat"></btn>
				</li>
			</ul>
			<div class="pop_right_main">
				<!-- main -->


				<ul class="form_list">

					<li>
						<p>
							集团采购后拥有集团总账号，集团旗下的个人账号可以进行集团认证，即将自己的个人账号与集团账号进行绑定，认证通过后，享有集团账号同等权益。
							<br />
							三种方式完成集团认证： 
							<br />
							1、IP验证：个人账号在集团IP范围内登录，即自动绑定集团并享有同等权益；
							<br />
							2、工作邮箱验证：具体操作请与集团管理员联系；
							<br />
							3、管理员邮箱验证：具体操作请与集团管理员联系； 
						</p>
					</li>
					<li>
						<h4>集团账号</h4>
						<div class="input_out">
							<div class="input_inner">
								<div class="input_box">
									<input type="text" class="s_input" v-model="bandingform.jtaccount">
								</div>
							</div>
							<btn class="btn-edit" @click="jtsearch()">查询</btn>
						</div>
					</li>
					<template v-if="!isorg && (iscanuwork || iscancomwork)">
						<li>
							<div class="">
								<ul class="mul-choice-list single">
									<li v-show="iscanuwork" @click="bandingform.type=1">
										<check class="cei-icon"
											v-bind:class="bandingform.type==1?'s-checked':'s-checkbox'"></check>工作邮箱验证
									</li>
									<li v-show="iscancomwork" @click="bandingform.type=2">
										<check class="cei-icon"
											v-bind:class="bandingform.type==2?'s-checked':'s-checkbox'"></check>管理员邮箱验证
									</li>
								</ul>
							</div>
						</li>
						<template v-if="bandingform.type==1">
							<li>
								<h4>工作邮箱</h4>
								<div class="input_out">
									<div class="input_inner">
										<div class="input_box">
											<input type="text" class="s_input" v-model="workemail.email"
												placeholder="请输入工作邮箱">
										</div>
									</div>
								</div>
							</li>
						</template>
						<template v-else-if="bandingform.type==2">
							<li>
								填写认证申请表
							</li>
							<li>
								<h4>姓名</h4>
								<div class="input_out">
									<div class="input_inner">
										<div class="input_box">
											<input type="text" class="s_input" v-model="compemail.name" placeholder="">
										</div>
									</div>
								</div>
							</li>
							<li>
								<h4>部门</h4>
								<div class="input_out">
									<div class="input_inner">
										<div class="input_box">
											<input type="text" class="s_input" v-model="compemail.department"
												placeholder="">
										</div>
									</div>
								</div>
							</li>
							<li>
								<h4>手机</h4>
								<div class="input_out">
									<div class="input_inner">
										<div class="input_box">
											<input type="text" class="s_input" v-model="compemail.phone" placeholder="">
										</div>
									</div>
								</div>
							</li>
							<li>
								<h4>座机</h4>
								<div class="input_out">
									<div class="input_inner">
										<div class="input_box">
											<input type="text" class="s_input" v-model="compemail.tel" placeholder="">
										</div>
									</div>
								</div>
							</li>
							<li>
								<h4>职位</h4>
								<div class="input_out">
									<div class="input_inner">
										<div class="input_box">
											<input type="text" class="s_input" v-model="compemail.job" placeholder="">
										</div>
									</div>
								</div>
							</li>
							<li>
								<h4>邮箱</h4>
								<div class="input_out">
									<div class="input_inner">
										<div class="input_box">
											<input type="text" class="s_input" v-model="compemail.email" placeholder="">
										</div>
									</div>
								</div>
							</li>
							<li>
								<h4>备注</h4>
								<div class="input_out">
									<div class="input_inner">
										<div class="input_box">
											<input type="text" class="s_input" v-model="compemail.note" placeholder="">
										</div>
									</div>
								</div>
							</li>
						</template>
					</template>

				</ul>


			</div><!-- /main -->

			<div v-if="bandingform.type==1" class="pop_right_footer2">
				<btn class="s_btn" @click="workemailSubmit()">确定</btn>
			</div>
			<div v-else-if="bandingform.type==2" class="pop_right_footer2">
				<btn class="s_btn" @click="compemailSubmit()">确定</btn>
			</div>

		</div><!-- /pop_right -->
		<div class="pop_bg" style="display: block;" @click="closeFloat"></div>
	</div><!-- /POP -->
</template>

<script>
	export default {
		data() {
			return {
				loadingMask: false,
				bandingform: {
					jtaccount: '',
					type: '',
					email: '',
				},
				workemail: {
					email: ''
				},
				compemail: {
					name: '',
					department: '',
					phone: '',
					tel: '',
					job: '',
					email: '',
					note: ''
				},
				isorg: false,
				isipcan: false,
				iscanuwork: false, // personal mail
				iscancomwork: false, // company one
				orgbtp: -1, // 0 ip 1 umail personal 1 com one pubmail
				workidemailVisiable: false,
				compidemailVisiable: false,
			}
		},
		props: [
			'userinfo'
		],
		mounted: function() {

		},
		methods: {
			jtsearch: function() {
				if (!this.bandingform.jtaccount) {
					this.$message({
						message: '请输入集团账号！',
						type: 'warning'
					});
					return false;
				}
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'post',
						url: 'UserInfo/Search',
						responseType: 'json',
						params: {
							g: this.bandingform.jtaccount
						},
					})
					.then(function(response) {
						if (response.data.data.data == '0' || response.data.data.data == '-1') {
							_this.$alert('未找到集团账号！', '提示信息', {
								confirmButtonText: '确定',
							});
							_this.bandingform.type = '',
								_this.isorg = false;
							_this.isipcan = false;
							_this.iscanuwork = false;
							_this.iscancomwork = false;
							_this.orgbtp = -1;
							_this.loadingMask = false;
							return false;
						} else {
							_this.bindState(response.data.data.data);

							_this.$track([
								['pagetype', '查询集团账号']
							]);
						}
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			bindState: function(state) {
				this.isorg = false;
				this.isipcan = false;
				this.iscanuwork = false;
				this.iscancomwork = false;
				this.orgbtp = -1;
				this.workidemailVisiable = false;
				this.compidemailVisiable = false;
				switch (state) {
					case "001":
						this.iscanuwork = true;
						this.workidemailVisiable = true;
						break;
					case "002":
						this.isorg = true;
						this.orgtp = 1
					case "010":
						this.iscancomwork = true;
						this.compidemailVisiable = true;
						break;
					case "100":
						this.isipcan = true;
						break;
					case "011":
						this.iscanuwork = true;
						this.workidemailVisiable = true;
						this.iscancomwork = true;
						this.compidemailVisiable = true;
						break;
					case "101":
						this.isipcan = true;
						this.iscanuwork = true;
						this.workidemailVisiable = true;
						break;
					case "102":
						this.isorg = true;
						break;
					case "110":
						this.isipcan = true;
						this.iscancomwork = true;
						this.compidemailVisiable = true;
						break;
					case "012":
						this.isorg = true;
						break;
					case "020":
						this.isorg = true;
						break;
					case "021":
						this.isorg = true;
						break;
					case "022":
						this.isorg = true;
						break;
					case "111":
						this.isipcan = true;
						this.iscanuwork = true;
						this.workidemailVisiable = true;
						this.iscancomwork = true;
						this.compidemailVisiable = true;
						break;
					case "112":
						this.isorg = true;
						break;
					case "120":
						this.isorg = true;
						break;
					case "121":
						this.isorg = true;
						break;
					case "122":
						this.isorg = true;
						break;
					case "200":
						this.isorg = true;

						break;
					case "201":
						this.isorg = true;

						break;
					case "202":
						this.isorg = true;

						break;
					case "210":
						this.isorg = true;

						break;
					case "211":
						this.isorg = true;

						break;
					case "212":
						this.isorg = true;

						break;
					case "220":
						this.isorg = true;

						break;
					case "221":
						this.isorg = true;

						break;
					case "222":
						this.isorg = true;

						break;
				}
			},
			workemailSubmit: function() {
				if (!this.workemail.email) {
					this.$message({
						message: '请填写邮箱',
						type: 'warning'
					});
					return false;
				} else {
					var regemail = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
					if (!regemail.test(this.workemail.email)) {
						this.$message({
							message: '请正确填写邮箱',
							type: 'warning'
						});
						return false;
					}
				}

				var online = this.onlineType();

				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'post',
						url: 'UserInfo/UMailBind',
						responseType: 'json',
						params: {
							m: this.workemail.email,
							onlineType: online
						},
					})
					.then(function(response) {
						var text = response.data.data.data
						if (text == "0" || text == "") {
							_this.$alert('邮件已发送，请到邮箱激活验证！', '成功', {
								confirmButtonText: '确定',
							});

							_this.$track([
								['pagetype', '工作邮箱绑定集团账号']
							]);
							
							_this.closeFloat();

						} else if (text == "1") {
							_this.$alert('邮件发送失败！', '失败', {
								confirmButtonText: '确定',
							});
						} else if (text == "4") {
							_this.$alert('该邮箱已经进行了集团验证，请更换邮箱！有问题请联系客服。电话：010-68140800、68140808， qq交流群：767104678。',
								'失败', {
									confirmButtonText: '确定',
								});
						} else if (text == "3") {
							_this.$alert(
								'请输入单位统一后缀的个人邮箱，如中经网单位员工输入后缀为：@cei.cn的单位邮箱方可进行验证！有问题请联系客服。电话：010-68140800、68140808， qq交流群：767104678。',
								'失败', {
									confirmButtonText: '确定',
								});
						} else {
							var msg = decodeURIComponent(text);
							_this.$alert(msg, '失败', {
								confirmButtonText: '确定',
							});
						}
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});

			},
			compemailSubmit: function() {
				if (!this.compemail.name &&
					!this.compemail.department &&
					!this.compemail.phone &&
					!this.compemail.tel &&
					!this.compemail.job &&
					!this.compemail.email &&
					!this.compemail.note) {
					this.$message({
						message: '请按管理员要求填写，如有疑问请与单位管理员联系！',
						type: 'warning'
					});
					return false;
				} else if (this.compemail.phone) {
					var regmobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[01678]|18[0-9]|14[57])[0-9]{8}$/;
					if (!regmobile.test(this.compemail.phone)) {
						this.$message({
							message: '请填写正确的手机号码',
							type: 'warning'
						});
						return false;
					}
				} else if (this.compemail.email) {
					var regemail = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
					if (!regemail.test(this.compemail.email)) {
						this.$message({
							message: '请正确填写邮箱',
							type: 'warning'
						});
						return false;
					}
				}
				
				let _this = this;
				_this.loadingMask = true;
				this.$prompt('请输入管理员邮箱', '管理员邮箱验证---管理员邮箱', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
					inputErrorMessage: '邮箱格式不正确'
				}).then(function(response) {
					var online = _this.onlineType();
					_this.$http({
							method: 'post',
							url: 'UserInfo/PubMailBind',
							responseType: 'json',
							params: {
								CoPubMail : response.value,
								vipname : _this.compemail.name,
								vipdepart : _this.compemail.department,
								vipmobile : _this.compemail.phone,
								vipduty : _this.compemail.job,
								vipemail : _this.compemail.email,
								vipnote : _this.compemail.note,
								unitnum : _this.compemail.tel,
								onlineType : online
							},
						})
						.then(function(response) {
							var text = response.data.data.data
							if (text == "0") {
								_this.$alert('邮件已发送，请等待管理员验证！', '成功', {
									confirmButtonText: '确定',
								});
					
								_this.$track([
									['pagetype', '管理员邮箱验证绑定集团']
								]);
								
								_this.closeFloat();
					
							} else if (text == "1") {
								_this.$alert('邮件发送失败！', '失败', {
									confirmButtonText: '确定',
								});
							} else if (text == "3") {
								_this.$alert(
									'公共邮箱输入不正确，请重新输入！',
									'失败', {
										confirmButtonText: '确定',
									});
							} else {
								var msg = decodeURIComponent(text);
								_this.$alert(msg, '失败', {
									confirmButtonText: '确定',
								});
							}
							_this.loadingMask = false;
						})
						.catch(function(error) {
							_this.loadingMask = false;
							console.log(error);
						});
					
				}).catch(function(error) {
					_this.loadingMask = false;
					console.log(error);
				});

			},
			closeFloat: function() {
				this.$emit('closefloat');
			},
			onlineType: function() {
				var sUserAgent = navigator.userAgent.toLowerCase();
				var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
				var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
				var bIsMidp = sUserAgent.match(/midp/i) == "midp";
				var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
				var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
				var bIsAndroid = sUserAgent.match(/android/i) == "android";
				var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
				var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
				// document.writeln("您的浏览设备为：");
				if (bIsUc7 || bIsUc) {
					return 1; //1网页 2手机 3pad 4 终端
				} else if (bIsIphoneOs || bIsMidp || bIsAndroid || bIsWM) {
					return 2;
				} else if (bIsIpad) {
					return 3;
				} else if (bIsCE || bIsWM) {
					return 4;
				} else {
					return 0;
				}
			}
		},
	}
</script>

<style>
</style>
